// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const thwackey: PokeData = {
  "id": 811,
  "name": "thwackey",
  "height": 7,
  "weight": 140,
  "base_experience": 147,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "scratch",
    "slam",
    "growl",
    "razor-leaf",
    "screech",
    "uproar",
    "taunt",
    "knock-off",
    "endeavor",
    "wood-hammer",
    "double-hit",
    "branch-poke"
  ],
  "moves": [
    "scratch",
    "growl",
    "razor-leaf",
    "wood-hammer",
    "branch-poke",
    "vine-whip",
    "energy-ball",
    "power-whip",
    "grassy-terrain",
    "solar-beam",
    "flower-rush",
    "leaf-tornado",
    "overgrowth"
  ],
  "evolution_chain": {
    "id": 430,
    "item": null,
    "species": [
      {
        "name": "grookey",
        "order": 810,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "thwackey",
        "order": 811,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 810,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "rillaboom",
        "order": 812,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 811,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 67.5,
    "speed": 80,
    "ability_power": 85
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
